import { render, staticRenderFns } from "./EventDocumentsPopup.vue?vue&type=template&id=1e2d10ed&scoped=true"
import script from "./EventDocumentsPopup.vue?vue&type=script&lang=js"
export * from "./EventDocumentsPopup.vue?vue&type=script&lang=js"
import style0 from "./EventDocumentsPopup.vue?vue&type=style&index=0&id=1e2d10ed&prod&lang=scss&scoped=true"
import style1 from "./EventDocumentsPopup.vue?vue&type=style&index=1&id=1e2d10ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2d10ed",
  null
  
)

export default component.exports